import { Card, CardBody, Col, Row } from "reactstrap";
import { TableContainer, Spinner, ScreenOverlay } from "../../../../components/Common";
import { useDeviceList } from "../../../../common/hooks/api/device";

import { COLUMNS } from "../../config";
import usePagination from "../../../../common/hooks/pagination";
import { toastError } from "../../../../helpers/toast-helper";
import {getResponseData} from "../../../../helpers/response-helper";
import { useNavigate } from "react-router-dom";
import { machineDetailPath } from "../../../../constants/machineRoutes";

const DeviceList = () => {
    const {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount,
    } = usePagination();

    const navigate = useNavigate();

    const { data: deviceList, isLoading } = useDeviceList(params, {
        onError: () => {
            toastError("Cannot fetch devices");
        }
    });

    const { data, meta } = getResponseData(deviceList);

    const pageCount = getPageCount(meta);

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardBody>
                        <TableContainer
                            columns={COLUMNS}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={true}
                            isAddButton={false}
                            buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                            buttonName="Add Machine"
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            manualPagination
                            paginationState={pagination}
                            onPaginationChange={setPagination}
                            pageCount={pageCount}

                            manualSorting
                            sortingState={sorting}
                            onSortingChange={setSorting}

                            manualGlobalFilter={true}
                            globalFilterState={globalFilter}
                            onGlobalFilterChange={setGlobalFilter}

                            onRowClick={(rowData) => {
                                navigate(machineDetailPath(rowData.serialNumber));
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </Row>
    );
};

export default DeviceList;
